/** Axios request timeout (ms). Override at build time via REACT_APP_API_TIMEOUT. */
const parsed = parseInt(process.env.REACT_APP_API_TIMEOUT, 10)

export const API_TIMEOUT_MS =
  Number.isFinite(parsed) && parsed > 0 ? parsed : 60000
